import { render } from "./AddonList.vue?vue&type=template&id=6d854893&scoped=true"
import script from "./AddonList.vue?vue&type=script&lang=js"
export * from "./AddonList.vue?vue&type=script&lang=js"

import "./AddonList.vue?vue&type=style&index=0&id=6d854893&scoped=true&lang=css"
import "./AddonList.vue?vue&type=style&index=1&id=6d854893&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d854893"]])

export default __exports__